/**
 * Resolve DELETE endpoint for bond type (law-firm + archives).
 */
export function getDeleteBondEndpoint(bondType, bondId) {
  const type = String(bondType || "").toLowerCase();
  switch (type) {
    case "blanket":
      return `/delete-blanket-bond/${bondId}/`;
    case "guardianship":
      return `/delete_guardianship_bond/${bondId}/`;
    case "probate":
      return `/delete_probate_bond/${bondId}/`;
    case "trustee":
      return `/delete_trustee_bond/${bondId}/`;
    case "va":
      return `/delete_va_bond/${bondId}/`;
    default:
      return null;
  }
}
